var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"dui-expandable-options"},_vm._l((_vm.availableOptions),function(option,index){return _c('DuiExpandableOption',{key:index,attrs:{"option":option},on:{"option-selected":_vm.optionSelected}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }